import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { formatDate, formatDateNews } from '../../utils/FormatDate'

import UrlFactory from '../../utils/UrlFactory'

import { HeadingSizeEnum } from '../Heading/Heading'
import {
  StyledBodyCard,
  StyledButton,
  StyledCard,
  StyledDate,
  StyledLabel,
  StyledParagraph,
  StyleHeading,
  StyleIcon,
} from './CardNews.styled'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import CardImage from '../CardImage/CardImage'
import ChipVariantEnum from '../../enums/ChipVariant'
import Chip from '../Chip/Chip'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'

const CardNews = (props) => {
  const {
    className,
    date,
    backgroundColor,
    category,
    ctaCardLabel,
    description,
    imageHeaderDesktop,
    imageHeaderMobile,
    isBasicPage,
    isOtherPage,
    thumbnail,
    title,
    slug,
  } = props

  const [dateForCard, setDateForCard] = useState(null)
  const isMobile = useMediaQuery(deviceMax.mobileL)

  const image =
    isMobile && imageHeaderMobile ? imageHeaderMobile : imageHeaderDesktop

  useEffect(() => {
    if (date) {
      setDateForCard(
        `${formatDateNews(date).split(',')[0].split(' ').reverse()},${
          formatDateNews(date).split(',')[1]
        }`
      )
    }
  }, [])

  return (
    <StyledCard className={className}>
      <CardImage
        image={image}
        thumbnail={thumbnail}
        backgroundColor={backgroundColor}
      />
      {category && <Chip label={category} variant={ChipVariantEnum.primary} />}
      {date && <StyledDate>{formatDate(date)}</StyledDate>}
      <StyledBodyCard>
        <StyleHeading label={title} size={HeadingSizeEnum.h3} />
        {description && <StyledParagraph>{description}</StyledParagraph>}
      </StyledBodyCard>
      <StyledButton
        to={
          isBasicPage
            ? UrlFactory.getBasicPageUrl(slug)
            : isOtherPage
            ? slug
            : UrlFactory.getNewsUrl(slug)
        }
        variant={ButtonVariantEnum.primary}
      >
        <StyledLabel>{ctaCardLabel}</StyledLabel>
        <StyleIcon />
      </StyledButton>
    </StyledCard>
  )
}

// TODO
CardNews.propTypes = {
  backgroundColor: PropTypes.string,
  category: PropTypes.string,
  ctaCardLabel: PropTypes.string.isRequired,
  description: PropTypes.string,
  imageHeaderDesktop: PropTypes.object,
  imageHeaderMobile: PropTypes.object,
  isBasicPage: PropTypes.bool,
  isOtherPage: PropTypes.bool,
  thumbnail: PropTypes.object,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
}

export default CardNews
